import { render, staticRenderFns } from "./addFilesModal2.vue?vue&type=template&id=9d4a1de8&"
import script from "./addFilesModal2.vue?vue&type=script&lang=js&"
export * from "./addFilesModal2.vue?vue&type=script&lang=js&"
import style0 from "./addFilesModal2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports